/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { PrintEntryPoint } from '@gh/common-shared-data';
import { entity, enumeration } from '@gh/core-data';
import { JobChecklistDto } from './job-checklists.dto';

export const JobChecklistMapper = entity<JobChecklistDto>({
  entryPoint: enumeration(PrintEntryPoint),
});
